import React from 'react';
import { CircularProgress, Grid, TextField } from '@material-ui/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { phoneRegex } from '../utils/regex';
import CustomButton from './CustomButton';

const CustomerForm = ({ disabled, handleCancel, handleCustomerCallback }) => {
  const { t } = useTranslation('general');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const valid = await formik.validateForm(formik.values);
    if(Object.keys(valid).length === 0) {
      handleCustomerCallback(formik.values);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required(t('Required Field')),
      email: Yup.string().email(t('Invalid Email')).required(t('Required Field')),
      phone: Yup.string()
        .matches(phoneRegex, { message: 'Invalid Phone' })
        .required(t('Required Field')),
    }),
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="mb-2">
        <TextField
          variant="outlined"
          name="name"
          label={t('Name')}
          className="w-full"
          error={!!formik.errors.name}
          helperText={formik.errors.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
      </div>
      <div className="sm:flex sm:justify-between sm:-mx-1 sm:pb-1">
        <div className="mb-2 sm:flex-1 sm:m-1">
          <TextField
            variant="outlined"
            name="email"
            label={t('Email')}
            className="w-full"
            error={!!formik.errors.email}
            helperText={formik.errors.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>
        <div className="mb-2 sm:flex-1 sm:m-1">
          <TextField
            variant="outlined"
            name="phone"
            label={t('Phone')}
            className="w-full"
            error={!!formik.errors.phone}
            helperText={formik.errors.phone}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>
      </div>
      <Grid container alignItems="center">
        <Grid item xs={6} className="pr-3">
          <CustomButton
            fullWidth
            type="button"
            color="background"
            disabled={disabled}
            onClick={handleCancel}
          >
            Anterior
          </CustomButton>
        </Grid>
        <Grid item xs={6}>
          <CustomButton
            fullWidth
            type="submit"
            variant="solid"
            color="primary"
            disabled={disabled}
            onClick={handleSubmit}
            className="my-5 px-16 py-3"
          >
            {disabled ? <CircularProgress color="white" size={24} /> : "Continuar"}
          </CustomButton>
        </Grid>
      </Grid>
    </form>
  );
};

export default CustomerForm;
